import { BrowserRouter as Router } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';

import { theme } from './styles/theme';
import AppProvider from './hooks';
import Routes from './routes';

const App: React.FC = () => (
	<Router>
		<ChakraProvider theme={theme}>
			<AppProvider>
				<Routes />
			</AppProvider>
		</ChakraProvider>
	</Router>
)

export default App;
